import { DataExtractionValueBase } from './DataExtractionValueBase';

export const __typename = 'DataExtractionValueMultipleSelectDto';
export class DataExtractionValueMultipleSelect extends DataExtractionValueBase {
  constructor(data = {}) {
    super({ ...data, __typename });
    this.valueArr = data.valueArr ?? [];
  }
}
